import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ServiceOffersService } from "../../../_services/serviceoffers.service";
import { CustomersService } from "../../../_services/customers.service";
import { StatisticsService } from "../../../_services/statistics.service";
import { ServiceAddonsService } from "../../../_services/serviceaddons.service";
import { KmCatchUpAgreement } from "../../../_models/kmCatchUpAgreement";
import { Dealer } from "../../../_models/dealer";
import { Http } from "@angular/http";
import { DealersService } from "app/_services/dealers.service";
import { ServiceOffer } from "../../../_models/serviceoffer";
import { ServiceAddon } from "../../../_models/serviceaddon";
import { StatisticEvent } from "../../../_models/statisticevent";
import { Customer } from "../../../_models/customer";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import {
  ToasterModule,
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { environment } from "../../../../environments/environment";
import { EnvironmentService } from "app/_services";
import { NgForm } from "@angular/forms";
import { KmCatchUpAgreementService } from "app/_services/matrix/products/km-catch-up-agreement.service";
import { Car } from "app/_models";
import { MonitorKmService } from "app/_services/monitorkm.service";
import { vehicleKmRecord } from "app/_models/vehicleKmRecord";

@Component({
  selector: "app-km-catch-up-checkout",
  templateUrl: "./checkout.component.html",
  providers: [
    ServiceOffersService,
    ServiceAddonsService,
    CustomersService,
    KmCatchUpAgreementService,
    DealersService,
    StatisticsService,
    MonitorKmService,
  ],
})
export class KmCatchUpCheckoutComponent implements OnInit {
  private serviceoffers: ServiceOffer[];
  private serviceaddons: ServiceAddon[];
  private customer: Customer;
  public data: Customer;
  private mauticCustomer: Customer;
  private statisticsService: StatisticsService;
  public hasResponded: boolean = false;
  public disableEmailField: boolean = true;

  private customerid: string = "";
  private kmRecordId: string = "";
  private kmRecord: vehicleKmRecord;
  public kmExceeded: number = 0;
  private errorMessage: string = "";
  public isLoading: boolean = true;
  private calcStartupCost: boolean = true;
  private confirmation: boolean = false;
  private userId: string;
  public customerAccept: boolean = false;
  public usedcar: Car[];
  private dealer: Dealer;

  public optin: boolean = true;
  public calculatedPrice: number;
  private serviceaddonslist: string;
  private carname: string = "";
  private payment_method: string = "";
  public startupPrice: number;
  public customer_data: Customer = new Customer();
  public kmCatchUpAgreement: KmCatchUpAgreement;
  public completedData;
  public pdf: any = "";

  // Getter for template compatibility
  public get catchUpAgreement(): KmCatchUpAgreement {
    return this.kmCatchUpAgreement;
  }

  private subscription: Subscription;

  private toasterService: ToasterService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  private host: String = environment.host;
  private port: String = environment.port;
  private authenticateUrl = this.environmentService.getBaseURL() + "/";

  public dealercalc: boolean;

  private offerSpecialPrice: boolean = false;
  private specialPrice: number = null;

  private showSearchByReg: boolean = true;

  constructor(
    toasterService: ToasterService,
    statisticsService: StatisticsService,
    private activatedRoute: ActivatedRoute,
    private kmCatchUpAgreementService: KmCatchUpAgreementService,
    private customersService: CustomersService,
    private dealerService: DealersService,
    private router: Router,
    private serviceAddonsService: ServiceAddonsService,
    private serviceoffersService: ServiceOffersService,
    private modalService: NgbModal,
    private environmentService: EnvironmentService,
    private monitorKmService: MonitorKmService
  ) {
    this.toasterService = toasterService;
    this.statisticsService = statisticsService;
    this.activatedRoute = activatedRoute;
  }

  ngOnInit() {
    this.isLoading = true;
    this.activatedRoute.params.subscribe(async (params) => {
      this.customerid = params["id"];
      this.kmRecordId = params["record"];
      
      console.log('Checkout - Customer ID:', this.customerid);
      console.log('Checkout - KM Record ID:', this.kmRecordId);
      
      // Get data from session storage
      this.kmCatchUpAgreement = JSON.parse(sessionStorage.getItem("kmCatchUpAgree"));
      this.completedData = JSON.parse(sessionStorage.getItem("kmCatchUpDetails"));
      
      if (this.kmCatchUpAgreement) {
        this.usedcar = this.kmCatchUpAgreement.car as Car[];
        // If we don't have a customerid from route, use the one from agreement
        if (!this.customerid && this.kmCatchUpAgreement.customer) {
          this.customerid = this.kmCatchUpAgreement.customer;
        }
      }

      // Fetch km record data - kmRecordId is always provided
      try {
        this.kmRecord = await this.monitorKmService.get(this.kmRecordId);
        // Use the already calculated exceeded km from the record
        this.kmExceeded = this.kmRecord.kmDifference || 0;
        console.log('KM Record loaded:', this.kmRecord);
        console.log('Exceeded kilometers from record:', this.kmExceeded);
      } catch (error) {
        console.error('Error fetching km record:', error);
        this.errorMessage = error;
        // Fallback to session storage data if km record fetch fails
        if (this.kmCatchUpAgreement && this.kmCatchUpAgreement.km) {
          this.kmExceeded = parseFloat(this.kmCatchUpAgreement.km);
        }
        if (this.completedData && this.completedData.kmExceeded) {
          this.kmExceeded = this.completedData.kmExceeded;
        }
      }

      try {
        this.userId = JSON.parse(localStorage.getItem("currentUser"))._id;
        if (this.customerid === this.userId) {
          this.customerAccept = true;
        }
      } catch (e) {
        // Handle case where currentUser is not available
      }

      this.customersService.read(this.customerid).subscribe(
        /* happy path */ (p) => (this.customer = p),
        /* error path */ (e) => (this.errorMessage = e),
        /* onComplete */ () => {
          this.data = this.customer;

          this.customersService
            .queryFromMautic(214, this.customer.dealer[0]._id, {
              attributeName: "regnr",
              attributeValue: this.customer.regnr,
            })
            .subscribe(
              (customer) => {
                if (!this.data.postnummer) {
                  this.data.postnummer = customer.postalcode;
                }
                if (!this.data.by) {
                  this.data.by = customer.city;
                }
                if (!this.data.address) {
                  this.data.address = customer.address 
                }
                if (this.showSearchByReg == true) {
                  this.customer_data = this.data;
                }
                if (this.customer_data.telefonnummer) {
                  if (this.customer_data.telefonnummer.length > 8) {
                    const phoneLength = this.customer_data.telefonnummer.length;
                    this.customer_data.telefonnummer = this.customer_data.telefonnummer.slice(phoneLength-8);
                  }
                }
                this.mauticCustomer = customer;
                if (!this.mauticCustomer.email) {
                  this.disableEmailField = false;
                }
              },
              (e) => (this.errorMessage = e),
              () => {
                if (this.customer_data && this.customer_data.dealer && this.customer_data.dealer[0] && this.customer_data.dealer[0]._id) {
                  this.dealerService
                    .get(this.customer_data.dealer[0]._id)
                    .subscribe(
                      (d) => {
                        this.dealer = d;
                      },
                      (e) => (this.errorMessage = e),
                      () => {
                        this.isLoading = false;
                      }
                    );
                } else {
                  console.warn('ngOnInit - No dealer_id available for dealer service call');
                  this.isLoading = false;
                }
              }
            );
        }
      );
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      this.dealercalc = params["dealercalc"] == "true";
    });
  }

  /**
   * Calculates expiration date by adding years to a start date
   * @param startDate - The start date
   * @param years - Number of years to add
   * @returns New date with years added
   */

  /**
   * Maps and populates all required fields for a KmCatchUpAgreement
   * @param baseAgreement - The base agreement to extend
   * @param isPreview - Whether this is for preview (affects status and customerAccept)
   * @returns Populated agreement item
   */
  private mapAgreementFields(baseAgreement: Partial<KmCatchUpAgreement>, isPreview: boolean = false): Partial<KmCatchUpAgreement> {
    // Validate that required data is available
    if (!this.customer_data) {
      console.warn('mapAgreementFields - customer_data is not available');
    }
    
    let agreementItem: Partial<KmCatchUpAgreement> = {
      ...baseAgreement,
      status: isPreview ? false : true,
      dealer_id: (this.customer_data && this.customer_data.dealer && this.customer_data.dealer[0] && this.customer_data.dealer[0]._id) || (this.customer && this.customer.dealer && this.customer.dealer[0] && this.customer.dealer[0]._id) || (this.kmCatchUpAgreement && this.kmCatchUpAgreement.dealer_id),
      calculatorType: "online",
      customerAccept: isPreview ? false : this.customerAccept,
      regnr: (this.customer_data && this.customer_data.regnr) || (this.mauticCustomer && this.mauticCustomer.regnr),
      department: (this.mauticCustomer && this.mauticCustomer.department) || (this.customer_data && this.customer_data.department),
      contract_date: new Date().toISOString().split('T')[0],
    };

    // Add kmCatchUp specific fields if customer data is available
    if (this.customer) {
      agreementItem.previousServiceAgreement = this.customer._id;
      agreementItem.previousServiceAgreementExpiration = this.customer.serviceAgreeEnd;
      agreementItem.previousServiceAgreementKilometers = this.customer.serviceAgreeKm;
    }

    // Update with latest km data if available
    if (this.kmRecord) {
      agreementItem.km = this.kmExceeded.toString();
      agreementItem.actualKm = (this.kmRecord.actualKm as number);
    } else if (!agreementItem.km && this.kmCatchUpAgreement.km) {
      agreementItem.km = this.kmCatchUpAgreement.km;
    }

    // Ensure actualkm is set
    if (!agreementItem.actualKm && this.kmCatchUpAgreement.actualKm) {
      agreementItem.actualKm = this.kmCatchUpAgreement.actualKm;
    }

    // Ensure kmExceeded is set
    if (!agreementItem.kmExceeded && this.kmCatchUpAgreement.kmExceeded) {
      agreementItem.kmExceeded = this.kmCatchUpAgreement.kmExceeded;
    }

    // Ensure lastservice is set
    if (!agreementItem.lastService && this.kmCatchUpAgreement.lastService) {
      agreementItem.lastService = this.kmCatchUpAgreement.lastService;
    }

    // Ensure years field is set
    if (!agreementItem.years && this.completedData && this.completedData.monthsNeeded) {
      agreementItem.years = Math.ceil(this.completedData.monthsNeeded / 12).toString();
    } else if (!agreementItem.years && this.kmCatchUpAgreement.years) {
      agreementItem.years = this.kmCatchUpAgreement.years;
    }

    // Ensure car field is set
    if (!agreementItem.car && this.usedcar) {
      agreementItem.car = this.usedcar;
    } else if (!agreementItem.car && this.kmCatchUpAgreement.car) {
      agreementItem.car = this.kmCatchUpAgreement.car;
    }

    // Set fields that should be empty (no defaults)
    agreementItem.addons = [];
    agreementItem.service_price = undefined;
    agreementItem.sellerInitials = undefined;

    // Set final_amount to totalPrice
    if (this.completedData && this.completedData.totalPrice) {
      agreementItem.final_amount = this.completedData.totalPrice;
    } else if (agreementItem.price) {
      agreementItem.final_amount = agreementItem.price;
    }

    // Calculate carMonthsOld: date.now() - firstreg
    if (this.mauticCustomer && this.mauticCustomer.firstreg) {
      const firstRegDate = new Date(this.mauticCustomer.firstreg);
      const now = new Date();
      const diffTime = Math.abs(now.getTime() - firstRegDate.getTime());
      agreementItem.carMonthsOld = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30.44)); // Approximate months
    } else if (this.customer_data && this.customer_data.firstreg) {
      // Fallback to customer_data if mauticCustomer is not available
      const firstRegDate = new Date(this.customer_data.firstreg);
      const now = new Date();
      const diffTime = Math.abs(now.getTime() - firstRegDate.getTime());
      agreementItem.carMonthsOld = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30.44)); // Approximate months
    }

    // Calculate monthsToGo: date.now() - currentServiceAgreementExpiration
    if (agreementItem.currentServiceAgreementExpiration) {
      const expirationDate = new Date(agreementItem.currentServiceAgreementExpiration);
      const now = new Date();
      const diffTime = Math.abs(expirationDate.getTime() - now.getTime());
      agreementItem.monthsToGo = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30.44)); // Approximate months
    } else if (this.completedData && this.completedData.monthsNeeded) {
      agreementItem.monthsToGo = this.completedData.monthsNeeded;
    }

    // Ensure customer field is set
    if (!agreementItem.customer && this.customerid) {
      agreementItem.customer = this.customerid;
    } else if (!agreementItem.customer && this.kmCatchUpAgreement.customer) {
      agreementItem.customer = this.kmCatchUpAgreement.customer;
    }
    
    // Validate that required fields are present
    if (!agreementItem.customer) {
      console.warn('mapAgreementFields - Missing customer field');
    }
    if (!agreementItem.car) {
      console.warn('mapAgreementFields - Missing car field');
    }
    if (!agreementItem.dealer_id) {
      console.warn('mapAgreementFields - Missing dealer_id field');
    }
    
    // Additional validation for dealer access
    if (!(this.customer_data && this.customer_data.dealer && this.customer_data.dealer[0] && this.customer_data.dealer[0]._id) && !(this.customer && this.customer.dealer && this.customer.dealer[0] && this.customer.dealer[0]._id) && !(this.kmCatchUpAgreement && this.kmCatchUpAgreement.dealer_id)) {
      console.warn('mapAgreementFields - No dealer_id available from any source');
    }

    // If special price is set, then set the agreement price to that
    if (this.specialPrice != null) {
      agreementItem.price = this.specialPrice;
    }

    // Set payout field for kmCatchUp agreement
    if (this.completedData && this.completedData.totalPrice) {
      agreementItem.payout = this.completedData.totalPrice;
    } else if (agreementItem.price) {
      agreementItem.payout = agreementItem.price;
    }

    // Ensure price is set if not already present
    if (!agreementItem.price && this.completedData && this.completedData.monthlyPrice) {
      agreementItem.price = this.completedData.monthlyPrice;
    } else if (!agreementItem.price && this.kmCatchUpAgreement.price) {
      agreementItem.price = this.kmCatchUpAgreement.price;
    }

    // Debug logging to see what's being mapped
    console.log('mapAgreementFields - Input baseAgreement:', baseAgreement);
    console.log('mapAgreementFields - Output agreementItem:', agreementItem);
    console.log('mapAgreementFields - completedData:', this.completedData);
    console.log('mapAgreementFields - kmCatchUpAgreement:', this.kmCatchUpAgreement);
    
    return agreementItem;
  }

  saveAgreement(checkoutForm: NgForm) {
    checkoutForm.form.disable();
    this.isLoading = true;

    // Use the mapping method to populate all required fields
    let agreementItem = this.mapAgreementFields(this.kmCatchUpAgreement, false);
    
    // Now using the dedicated KmCatchUpAgreementService
    if (this.kmCatchUpAgreement._id != undefined) {
      this.kmCatchUpAgreementService
        .update(agreementItem, this.completedData ? this.completedData.monthsNeeded : undefined)
        .subscribe(
          /* happy path */ (r) => {
            this.agreementDone();
            checkoutForm.form.enable();
            this.isLoading = false;
          },
          /* error path */ (e) => {
            this.errorMessage = e;
            checkoutForm.form.enable();
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = true;
      let customerItem: Customer = new Customer();
      customerItem._id = this.customerid;
      customerItem.name = this.customer_data.name;
      customerItem.address = this.customer_data.address;
      customerItem.postnummer = this.customer_data.postnummer;
      customerItem.by = this.customer_data.by;
      customerItem.email = this.customer_data.email;
      customerItem.telefonnummer = this.customer_data.telefonnummer;
      customerItem.regnr = this.customer_data.regnr;
      customerItem.firstreg = this.mauticCustomer.firstreg;
      
      this.customersService.update(customerItem).subscribe(
        /* happy path */ (r) => {},
        /* error path */ (e) => (this.errorMessage = e),
        /* onComplete */ () => {
          this.kmCatchUpAgreementService
            .create(agreementItem, this.completedData ? this.completedData.monthsNeeded : undefined)
            .subscribe(
              /* happy path */ (r) => {
                this.agreementDone();
                this.kmCatchUpAgreement = r;
                checkoutForm.form.enable();
                this.isLoading = false;
              },
              /* error path */ (e) => {
                this.errorMessage = e;
                checkoutForm.form.enable();
                this.isLoading = false;
              }
            );
        }
      );
    }

    let statisticEvent: StatisticEvent = new StatisticEvent();
    statisticEvent.customer = this.customer._id;
    statisticEvent.event = "km_catch_up_checkout_complete";
    this.statisticsService.sendEvent(statisticEvent).subscribe(
      /* happy path */ (r) => {
        console.log("km-catch-up checkout complete event tracked");
      },
      /* error path */ (e) => {
        console.error(`km-catch-up checkout complete event error: ${e}`);
      }
    );
  }

  previewPDF() {
    let customerItem: Customer = new Customer();
    customerItem._id = this.customerid;
    customerItem.name = this.customer_data.name;
    customerItem.address = this.customer_data.address;
    customerItem.postnummer = this.customer_data.postnummer;
    customerItem.by = this.customer_data.by;
    customerItem.email = this.customer_data.email;
    customerItem.telefonnummer = this.customer_data.telefonnummer;
    customerItem.firstreg = this.mauticCustomer.firstreg;

    // Use the mapping method to populate all required fields
    let agreementItem = this.mapAgreementFields(this.kmCatchUpAgreement, true);

    this.customersService.update(customerItem).subscribe(
      /* happy path */ (r) => {},
      /* error path */ (e) => (this.errorMessage = e),
      /* onComplete */ () => {
        this.isLoading = true;
        if (this.kmCatchUpAgreement._id == undefined) {
          this.kmCatchUpAgreementService
            .create(agreementItem, this.completedData ? this.completedData.monthsNeeded : undefined)
            .subscribe(
              /* happy path */ (r) => {
                this.kmCatchUpAgreement = r;
                this.kmCatchUpAgreement.car = this.usedcar;
                this.isLoading = false;
                var tabWindowId = window.open("about:blank", "_blank");
                const redirectUrl =
                  this.authenticateUrl +
                  "api/agreement/kmCatchUp/offer_" +
                  r._id +
                  ".pdf";
                window.setTimeout(function () {
                  tabWindowId.location.href = redirectUrl;
                }, 3000);
              },
              /* error path */ (e) => {
                try {
                  const newAgreement = JSON.parse(e._body);
                  if (newAgreement.agreementGenerated != "") {
                    this.kmCatchUpAgreement = newAgreement.agreementGenerated;
                    this.kmCatchUpAgreement.car = this.usedcar;
                  } else {
                    this.kmCatchUpAgreement = JSON.parse(
                      sessionStorage.getItem("kmCatchUpAgree")
                    );
                  }
                } catch (parseError) {
                  this.kmCatchUpAgreement = JSON.parse(
                    sessionStorage.getItem("kmCatchUpAgree")
                  );
                }
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        } else {
          this.kmCatchUpAgreementService
            .update(agreementItem, this.completedData ? this.completedData.monthsNeeded : undefined)
            .subscribe(
              /* happy path */ (r) => {
                this.kmCatchUpAgreement = r;
                this.kmCatchUpAgreement.car = this.usedcar;
                var tabWindowId = window.open("about:blank", "_blank");
                this.isLoading = false;

                const redirectUrl =
                  this.authenticateUrl +
                  "api/agreement/kmCatchUp/offer_" +
                  this.kmCatchUpAgreement._id +
                  ".pdf";

                window.setTimeout(function () {
                  tabWindowId.location.href = redirectUrl;
                }, 3000);
              },
              /* error path */ (e) => {
                try {
                  const newAgreement = JSON.parse(e._body);
                  if (newAgreement.agreementGenerated != "") {
                    this.kmCatchUpAgreement = newAgreement.agreementGenerated;
                    this.kmCatchUpAgreement.car = this.usedcar;
                  } else {
                    this.kmCatchUpAgreement = JSON.parse(
                      sessionStorage.getItem("kmCatchUpAgree")
                    );
                  }
                } catch (parseError) {
                  this.kmCatchUpAgreement = JSON.parse(
                    sessionStorage.getItem("kmCatchUpAgree")
                  );
                }
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        }
      }
    );
  }

  previewTC() {
    let customerItem: Customer = new Customer();
    customerItem._id = this.customerid;
    customerItem.name = this.customer_data.name;
    customerItem.address = this.customer_data.address;
    customerItem.postnummer = this.customer_data.postnummer;
    customerItem.by = this.customer_data.by;
    customerItem.email = this.customer_data.email;
    customerItem.telefonnummer = this.customer_data.telefonnummer;
    customerItem.regnr = this.customer_data.regnr;
    customerItem.firstreg = this.mauticCustomer.firstreg;

    // Use the mapping method to populate all required fields
    let agreementItem = this.mapAgreementFields(this.kmCatchUpAgreement, true);

    this.customersService.update(customerItem).subscribe(
      /* happy path */ (r) => {},
      /* error path */ (e) => (this.errorMessage = e),
      /* onComplete */ () => {
        this.isLoading = true;
        if (this.kmCatchUpAgreement._id == undefined) {
          this.kmCatchUpAgreementService
            .create(agreementItem, this.completedData ? this.completedData.monthsNeeded : undefined)
            .subscribe(
              /* happy path */
              (r) => {
                this.kmCatchUpAgreement = r;
                this.kmCatchUpAgreement.car = this.usedcar;
                this.isLoading = false;
                var tabWindowId = window.open("about:blank", "_blank");
                const redirectUrl =
                  this.authenticateUrl +
                  "api/agreement/kmCatchUp/tc_" +
                  r._id +
                  ".pdf";
                window.setTimeout(function () {
                  tabWindowId.location.href = redirectUrl;
                }, 3000);
              },
              /* error path */
              (e) => {
                try {
                  const newAgreement = JSON.parse(e._body);
                  if (newAgreement.agreementGenerated != "") {
                    this.kmCatchUpAgreement = newAgreement.agreementGenerated;
                    this.kmCatchUpAgreement.car = this.usedcar;
                  } else {
                    this.kmCatchUpAgreement = JSON.parse(
                      sessionStorage.getItem("kmCatchUpAgree")
                    );
                  }
                } catch (parseError) {
                  this.kmCatchUpAgreement = JSON.parse(
                    sessionStorage.getItem("kmCatchUpAgree")
                  );
                }
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        } else {
          this.kmCatchUpAgreementService
            .update(agreementItem, this.completedData ? this.completedData.monthsNeeded : undefined)
            .subscribe(
              /* happy path */
              (r) => {
                this.kmCatchUpAgreement = r;
                this.kmCatchUpAgreement.car = this.usedcar;

                var tabWindowId = window.open("about:blank", "_blank");
                this.isLoading = false;
                tabWindowId.location.href =
                  this.authenticateUrl +
                  "api/agreement/kmCatchUp/tc_" +
                  this.kmCatchUpAgreement._id +
                  ".pdf";
              },
              /* error path */
              (e) => {
                try {
                  const newAgreement = JSON.parse(e._body);
                  if (newAgreement.agreementGenerated != "") {
                    this.kmCatchUpAgreement = newAgreement.agreementGenerated;
                    this.kmCatchUpAgreement.car = this.usedcar;
                  } else {
                    this.kmCatchUpAgreement = JSON.parse(
                      sessionStorage.getItem("kmCatchUpAgree")
                    );
                  }
                } catch (parseError) {
                  this.kmCatchUpAgreement = JSON.parse(
                    sessionStorage.getItem("kmCatchUpAgree")
                  );
                }
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        }
      }
    );
  }

  viewPDF() {
    let customerItem: Customer = new Customer();
    
    // Use the mapping method to populate all required fields
    let agreementItem = this.mapAgreementFields(this.kmCatchUpAgreement, false);
    
    // Debug logging to see what's being sent
    console.log('viewPDF - Final agreementItem:', agreementItem);
    console.log('viewPDF - completedData:', this.completedData);
    console.log('viewPDF - kmCatchUpAgreement:', this.kmCatchUpAgreement);
    
    customerItem._id = this.customerid;
    customerItem.name = this.customer_data.name;
    customerItem.address = this.customer_data.address;
    customerItem.postnummer = this.customer_data.postnummer;
    customerItem.by = this.customer_data.by;
    customerItem.email = this.customer_data.email;
    customerItem.telefonnummer = this.customer_data.telefonnummer;
    customerItem.firstreg = this.mauticCustomer.firstreg;
    

    var tabWindowId = window.open("about:blank", "_blank");

    this.customersService.update(customerItem).subscribe(
      /* happy path */ (r) => {},
      /* error path */ (e) => (this.errorMessage = e),
      /* onComplete */ () => {
        if (this.kmCatchUpAgreement._id == undefined) {
          this.kmCatchUpAgreementService
            .create(agreementItem, this.completedData ? this.completedData.monthsNeeded : undefined)
            .subscribe(
              /* happy path */
              (r) => {
                this.kmCatchUpAgreement = r;
                this.isLoading = false;
                tabWindowId.location.href =
                  this.authenticateUrl +
                  "api/agreement/agreement_" +
                  r._id +
                  ".pdf";
              },
              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        } else {
          this.kmCatchUpAgreementService
            .update(agreementItem, this.completedData ? this.completedData.monthsNeeded : undefined)
            .subscribe(
              /* happy path */
              (r) => {
                this.isLoading = false;
                tabWindowId.location.href =
                  this.authenticateUrl +
                  "api/agreement/agreement_" +
                  this.kmCatchUpAgreement._id +
                  ".pdf";
              },

              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        }
      }
    );
  }

  agreementDone() {
    sessionStorage.removeItem("kmCatchUpAgree");
    sessionStorage.removeItem("kmCatchUpDetails");
    this.confirmation = true;
  }

  back() {
    window.history.back();
  }
} 


// WEBPACK FOOTER //
// ./src/app/landingpages/kmCatchUp/order-flow/checkout.component.ts